import React from 'react';
import IrLogomarkRed from './logo/Ingersoll-Rand-logomark-RGB-72-dpi.png';

const LogoIcon = () => {
 return <img src={IrLogomarkRed} alt='Ingersoll Rand Logo'/>; 
};

export default LogoIcon;
